const productsSort = (form = '.js-support-form',  tabBtnClass = '.js-support-tab-link', tabClass = '.js-tab', parentClass='.support') => {

    function renderQuantity(container){
        let quantityInfo = $(container).find('.js-support-count'),
            slug = $(container).attr('data-container'),
            btn = $(`${tabBtnClass}[data-slug=${slug}]`),
            btnCount = btn.find('.js-tab-count');

        if(quantityInfo.length > 0 ){
            let count = quantityInfo.text();

            if(btnCount.length > 0){
                btnCount.html(`&nbsp;(${count})`)
            } else {
                btn.append(`<span class="js-tab-count">&nbsp;(${count})</span>`);
            }
        } else {
            if(btnCount.length > 0){
                btnCount.remove();
            }
        }
    }

    if($(parentClass).length > 0) {
        $(form).on('submit', (ev) => {
            // ev.preventDefault();
            let parent = $(ev.currentTarget).parents(parentClass),
                tabBtn = $(parent).find(tabBtnClass);

            let query = $(ev.currentTarget).find('input[type=search]').val();

            $(tabBtn).each((i, btn)=> {
                let slug = $(btn).attr('data-slug'),
                    data = {
                        action: 'support_search',
                        slug: slug,
                        query: query
                    };

                    $.ajax({
                        type: 'POST',
                        url: ajax_url[0],
                        dataType: "html",
                        data: data,
                        success: function (response) {
                            let container = $(`${tabClass}[data-container=${slug}]`);
                            container.html(response);
                            setTimeout(() => {
                                renderQuantity(container);
                            }, 100)

                        },
                        error: function (error) {
                            console.log('error', error);
                        }
                    });
            })
        });

    }
};

export default productsSort;